import { useState, useEffect, useRef } from "react";
import { useData } from "./DataContext.js";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";

import { PencilFill, XLg } from "react-bootstrap-icons";

import FormGroup from "./FormGroup.js";
import ButtonGrid from "./ButtonGrid.js";

export default function EditTeacherModal (props)
{
    const gData = useData();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [institution, setInstitution] = useState("");
    const [mailAddress, setMailAddress] = useState("");
    //const [password, setPassword] = useState("");

    const [editFirstName, setEditFirstName] = useState(false);
    const [editLastName, setEditLastName] = useState(false);
    const [editInstitution, setEditInstitution] = useState(false);
    const [editMailAddress, setEditMailAddress] = useState(false);
    //const [editPassword, setEditPassword] = useState(false);

    const firstNameRef = useRef(null);
    const lastNameRef = useRef(null);
    const institutionRef = useRef(null);
    const mailAddressRef = useRef(null);
    //const passwordNameRef = useRef(null);

    useEffect (() => {
	if (gData.teacher !== null && gData.teacher[gData.teacherID] !== undefined)
	{
	    const teacher = gData.teacher[gData.teacherID];
	    setFirstName(teacher.firstName);
	    setLastName(teacher.lastName);
	    setInstitution(teacher.institution);
	    setMailAddress(teacher.mailAddress);
	    //setPassword(teacher.password);
	}
    }, [gData.teacherID, gData.teacher, props.show]);

    useEffect (() => { if (editFirstName === true) firstNameRef.current.focus(); }, [editFirstName]);
    useEffect (() => { if (editLastName === true) lastNameRef.current.focus(); }, [editLastName]);
    useEffect (() => { if (editInstitution === true) institutionRef.current.focus(); }, [editInstitution]);
    useEffect (() => { if (editMailAddress === true) mailAddressRef.current.focus(); }, [editMailAddress]);
    //useEffect (() => { if (editPassword === true) passwordRef.current.focus(); }, [editPassword]);
    
    const [validated, setValidated] = useState(false);

    function handleFirstNameChange (e) { setFirstName(e.target.value); }
    function handleLastNameChange (e) { setLastName(e.target.value); }
    function handleInstitutionChange (e) { setInstitution(e.target.value); }
    function handleMailAddressChange (e) { setMailAddress(e.target.value); }
    //function handlePasswordChange (e) { setPassword(e.target.value); }

    function toggleEditFirstName (e) { if (editFirstName) { setEditFirstName(false); setFirstName(gData.teacher[gData.teacherID].firstName); } else setEditFirstName(true); }
    function toggleEditLastName (e) { if (editLastName) { setEditLastName(false); setLastName(gData.teacher[gData.teacherID].lastName); } else setEditLastName(true); }
    function toggleEditInstitution (e) { if (editInstitution) { setEditInstitution(false); setInstitution(gData.teacher[gData.teacherID].institution); } else setEditInstitution(true); }
    function toggleEditMailAddress (e) { if (editMailAddress) { setEditMailAddress(false); setMailAddress(gData.teacher[gData.teacherID].mailAddress); } else setEditMailAddress(true); }
    //function toggleEditPassword (e) { if (editPassword) { setEditPassword(false); setPassword(gData.teacher[gData.teacherID].password); } else setEditPassword(true); }

    function hide ()
    {
	const teacher = gData.teacher[gData.teacherID];
	setFirstName(teacher.firstName);
	setLastName(teacher.lastName);
	setInstitution(teacher.institution);
	setMailAddress(teacher.mailAddress);
	//setPassword(teacher.password);
	
	setEditFirstName(false);
	setEditLastName(false);
	setEditInstitution(false);
	setEditMailAddress(false);
	//setEditPassword(false);

	setValidated(false);
	props.hide();
    }
    
    function handleHide (e) { hide(); }

    function handleSubmit (e)
    {
	e.preventDefault();
	if (e.target.checkValidity()) {
	    props.submit({ firstName, lastName, institution, mailAddress }); // password
	    hide();
	}

	else setValidated(true);
    }

    return (
	<Modal
	    show={props.show}
	    onHide={handleHide}
	    centered
	>
	    <Modal.Header>
		<Modal.Title>Paramètres du compte</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		<Form
		    id="signinForm"
			noValidate validated={validated}
			onSubmit={handleSubmit}
		    className="d-flex flex-column gap-3"
		>
		    <FormGroup formId="signinForm" controlID="lastName" label="Nom">
			<InputGroup>
			    <Form.Control
				type="text"
				      required
				ref={lastNameRef}
				      disabled={!editLastName}
				      readOnly={!editLastName}
				      value={lastName}
				      onChange={handleLastNameChange}
			    />
			    {editLastName ?
			     (<Button variant="outline-secondary" onClick={toggleEditLastName}><XLg/></Button>) :
			     (<Button variant="primary" onClick={toggleEditLastName}><PencilFill/></Button>)
			    }
			</InputGroup>
		    </FormGroup>
		    
		    <FormGroup formId="signinForm" controlID="firstName" label="Prénom">
			<InputGroup>
			    <Form.Control
				type="text"
				required
 				ref={firstNameRef}
				disabled={!editFirstName}
				readOnly={!editFirstName}
				value={firstName}
				onChange={handleFirstNameChange}
			    />
			    {editFirstName ?
			     (<Button variant="outline-secondary" onClick={toggleEditFirstName}><XLg/></Button>) :
			     (<Button variant="primary" onClick={toggleEditFirstName}><PencilFill/></Button>)
			    }
			</InputGroup>
		    </FormGroup>

		    <FormGroup formId="signinForm" controlID="institution" label="Établissement">
			<InputGroup>
			    <Form.Control
				type="text"
				required
 				ref={institutionRef}
				disabled={!editInstitution}
				readOnly={!editInstitution}
				value={institution}
				onChange={handleInstitutionChange}
			    />
			    {editInstitution ?
			     (<Button variant="outline-secondary" onClick={toggleEditInstitution}><XLg/></Button>) :
			     (<Button variant="primary" onClick={toggleEditInstitution}><PencilFill/></Button>)
			    }
			</InputGroup>
		    </FormGroup>

		    <FormGroup formId="signinForm" controlID="mailAddress" label="Adresse courriel">
			<InputGroup>
			    <Form.Control
				type="text"
				required
 				ref={mailAddressRef}
				disabled={!editMailAddress}
				readOnly={!editMailAddress}
				value={mailAddress}
				onChange={handleMailAddressChange}
			    />
			    {editMailAddress ?
			     (<Button variant="outline-secondary" onClick={toggleEditMailAddress}><XLg/></Button>) :
			     (<Button variant="primary" onClick={toggleEditMailAddress}><PencilFill/></Button>)
			    }
			</InputGroup>
		    </FormGroup>

		    {/* <FormGroup formId="signinForm" controlID="password">
			<Form.Label column sm={4}>Mot de passe</Form.Label>
			<Col sm={8}>
			<InputGroup>
			<Form.Control
			type="password"
			required
 			ref={passwordRef}
			disabled={!editPassword}
			readOnly={!editPassword}
			value={password}
			onChange={handlePasswordChange}
			/>
			{editPassword ?
			(<Button variant="outline-secondary" onClick={toggleEditPassword}><XLg/></Button>) :
			(<Button variant="primary" onClick={toggleEditPassword}><PencilFill/></Button>)
			}
			</InputGroup>
			</Col>
			</FormGroup> */}

		</Form>
	    </Modal.Body>
	    
	    <Modal.Footer>
		<ButtonGrid>
		    <ButtonGrid.Left>
			<Button variant="outline-secondary" size="md" onClick={handleHide}>Annuler</Button>		    </ButtonGrid.Left>
		    <ButtonGrid.Right>
			<Button variant="primary" size="md" type="submit" form="signinForm">Enregistrer</Button>
		    </ButtonGrid.Right>
		</ButtonGrid>
	    </Modal.Footer>
	</Modal>
    );
}
